import { render } from "./NewInHouseMail.vue?vue&type=template&id=4dae8bda"
import script from "./NewInHouseMail.vue?vue&type=script&lang=js"
export * from "./NewInHouseMail.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__